module.exports = shared.lodash;